import React from 'react';
import {theme} from "../../../../core/theme/theme";
import {sendDataToParent} from "../../../Map/base/functions/sendDataToParent";

interface IPropsType {
    id : string,
    title : string,
    color : string
}

const CustomActionButton : React.FC<IPropsType> = (
    {
        id,
        title,
        color
    }
) => {

    const handleOnClick = (id:any)=>{
        sendDataToParent({
            type : "button-clicked-id",
            id : id,
        })
    }

    return (
        <>
            <button
                type="button"
                id={id}
                style={{
                width : "60px" ,
                height : "50px" ,
                position: 'absolute',
                paddingLeft: 10,
                paddingRight: 20,
                bottom: 30,
                right: 100,
                zIndex: 400,
                backgroundColor: `${color}`,
                fontStyle: 'italic',
                opacity: 0.7,
                borderRadius : "5px"
            }}
                onClick={()=>{
                    handleOnClick(id)
                }}
            >
                {title}
            </button>
        </>
    );
};

export default CustomActionButton;